export const BubblesMenuItem = (value: string) => {
  const Component = () => (
    <div className="flex items-center justify-center">
      <span
        className="flex border font-bold border-black shadow-none m-0 rounded-full justify-center items-center text-sm p-2"
        style={{ borderWidth: 2, height: 20, width: 20 }}
      >
        {value}
      </span>
    </div>
  )

  Component.displayName = 'BubblesMenuItem'

  return Component
}
